import React, { Component } from 'react'
import { connect } from 'react-redux'
import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import { Preloader } from '../../components/Chart/index'
import Multi from '../../components/Multi'
import debounce from 'lodash/debounce'
import './style.css'
import axios from 'axios'
import ReactTooltip from 'react-tooltip'
import 'react-circular-progressbar/dist/styles.css'
import { getCookieType } from '../../lib/format-cookie-types'
import RoundBlueButton from '../../components/BorderButton/round-blue-button'
import Alert from 'react-s-alert'
import { RangeSelector } from '../revenue/range-selector'
import moment from 'moment'
import { formatNumber, getPercentage, numberWithCommas } from '../../lib/format-number'
import { dayStart, dayEnd, earlierDate } from '../../lib/format-date'
import { isAdmin } from '../../lib/check-user'
import ACLCheckPermission from '../../components/ACLCheckPermission'
import { Storage } from 'aws-amplify'


class Events extends Component {
    debouncedFilter = null

    state = {
        size: 20,
        offset: 0,
        events: [],
        loading: false,

    }

    componentDidMount() {
        
        this.setState({loading: true}, () =>{
            axios.get('/event?offset=0&size=1000&update=1').then(response => {
                console.log('fetch events response', response)

                let events = response.data.body.map(el=>{
                    if(el.messageJson && el.messageJson != ''){
                        try{
                            el.messageJson=JSON.parse(el.messageJson); 
                        }catch(err){
                            console.error(err)
                        }
                    }
                    return el;
                })
                console.log(events)

                this.setState({events: events, loading: false})
            })
        })

    }

    
    getDownloadLink(fileBucket, fileKey, index) {

        axios.get('/events/downloadurl?s3Bucket=' + fileBucket + '&s3Prefix=' + fileKey).then(response => {
            console.log('downloadurl response', response)
            window.open(response.data.body, '_blank')

        })
        
    }

    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <Multi>
                       

                        {this.state.loading && this.state.events.length === 0 ? (
                            <Preloader transparent />
                        ) : (
                            <div className="row">
                                <div className="col-lg-12">
                                    <WhiteBox customStyle={{ overflow: 'visible' }}>
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            <h3 className="box-title">Event Log:</h3>
                                            <div style={{ flex: 1 }} />

                                            
                                        </div>

                                        {this.state.events.length > 0 && (
                                            <table className="segment-list segment-list--table">
                                                <thead>
                                                    <tr className="audience-list audience-list--header">
                                                        <th style={{ width: '150px' }}>
                                                            Date/Time
                                                        </th>
                                                        <th style={{ width: '150px' }}>
                                                            User
                                                        </th>
                                                        <th >Description</th>
                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.events.map((event, index) => (
                                                        <tr key={'row-data-' + event.txId} className={`audience-list audience-list--row`}>
                                                            
                                                            <td className="" style={{'verticalAlign': 'top'}}>
                                                                {new Date(event.creation).toLocaleDateString()} {new Date(event.creation).toLocaleTimeString()}
                                                            </td>

                                                            <td className="" style={{'verticalAlign': 'top'}}>
                                                                {event.user}
                                                            </td>

                                                            <td className="" style={{'verticalAlign': 'top'}}>
                                                                {event.status === 'DONE' && event.messageJson && event.messageJson.errors && (
                                                                    <span class="badge badge-danger">ERROR</span>
                                                                )}
                                                                {event.status === 'DONE' && event.messageJson && !event.messageJson.errors && (
                                                                    <span class="badge badge-success">{event.status}</span>
                                                                )}
                                                                {event.status === 'PENDING' && (
                                                                    <span class="badge badge-secondary">{event.status}</span>
                                                                )}
                                                                {event.status === 'IN PROCESS' && (
                                                                    <span class="badge badge-info">{event.status}</span>
                                                                )}
                                                                &#160;
                                                                <br/>
                                                                <b>{event.description}</b>

                                                                {/* buyer reports download */}
                                                                {event.description === "Revenue buyer export" && (
                                                                    <span>
                                                                        <br/>
                                                                        <b>File Links:</b>
                                                                        <br/>
                                                                        <a href="#" target onClick={() => {
                                                                            this.getDownloadLink(event.messageJson.bucket, event.messageJson.prefix)
                                                                        }}>Download report</a>  
                                                                    </span>
                                                                )}

                                                                {/* Bulk license import - shows error list from the messageJson  */}
                                                                {event.description === "Bulk license import" && event.messageJson && event.messageJson.errors && (
                                                                    <span>
                                                                        <br/>
                                                                        <a href="#" class="" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                                                                            Show Error List
                                                                        </a>    

                                                                        <br/>
                                                                        <div class="collapse" id="collapseExample" style={{'margin-bottom': '5px'}}>
                                                                            <div class="card card-body">
                                                                                <b>Error List:</b>
                                                                                <ul>
                                                                                    {event.messageJson.errors.map(el => (
                                                                                        <li>{el}</li>
                                                                                    ))}
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </span>
                                                                )}



                                                            </td>
                                                            
                                                        </tr>
                                                    ))}

                                                    
                                                </tbody>
                                            </table>
                                        )}

                                        {this.state.events.length == 0 && (
                                            <div className="empty-page">
                                                <h2 className="empty-page empty-page--title">No events found.</h2>
                                            </div>
                                        )}
                                    </WhiteBox>
                                </div>
                            </div>
                        )}
                    </Multi>
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Events)
